module.exports = __webpack_public_path__ + "img/logo.8b15b90e.webp";